import { OrganizationSubscription } from '~/services/apiClient'

/**
 * Minimal shape needed to classify an org — satisfied by both the raw
 * `GETOrganization` API type and the `Organization` model.
 */
interface HasSubscriptions {
  subscriptions: OrganizationSubscription[]
}

/**
 * A "UTAS-only" org has exactly one subscription, UAS. These orgs are served by the
 * dedicated UTAS app (uas.draydog.com), not the main app — so the main app redirects
 * users whose current org is UTAS-only over to it.
 */
export function isUTASOnlyOrg(org: HasSubscriptions): boolean {
  return (
    org.subscriptions.length === 1 &&
    org.subscriptions.includes(OrganizationSubscription.Uas)
  )
}
